import { useState } from "react";
import Api from "../../../shared/api/api";

export default function PdfAdminList({
  pdfs = [],
  setPdfs,
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [deletingKey, setDeletingKey] = useState("");
  const [error, setError] = useState("");

  const deletePdf = async (userId, testId) => {
    const confirmed = window.confirm(
      `Delete the PDF for user ${userId} and test ${testId}?`
    );

    if (!confirmed) {
      return;
    }

    const pdfKey = `${userId}-${testId}`;

    setDeletingKey(pdfKey);
    setError("");

    try {
      const response = await Api.deleteSingle(
        "pdf",
        userId,
        testId
      );

      if (response?.error) {
        throw new Error(response.error);
      }

      if (typeof setPdfs === "function") {
        setPdfs((currentPdfs) =>
          currentPdfs.filter(
            (pdf) =>
              !(
                pdf.user_id === userId &&
                pdf.test_id === testId
              )
          )
        );
      }
    } catch (requestError) {
      console.error(
        "Unable to delete FourH PDF:",
        requestError
      );

      setError(
        requestError?.message ||
          "The PDF could not be deleted."
      );
    } finally {
      setDeletingKey("");
    }
  };

  return (
    <section className="pdfListDiv">
      <button
        type="button"
        className="adminHeaders adminSectionToggle"
        onClick={() =>
          setIsVisible((currentValue) => !currentValue)
        }
        aria-expanded={isVisible}
        aria-controls="fourh-pdf-list"
      >
        <span>
          User Assessment PDFs in the Database
        </span>

        <span aria-hidden="true">
          {isVisible ? "−" : "+"}
        </span>
      </button>

      {error && (
        <p className="fourHFormStatus error" role="alert">
          {error}
        </p>
      )}

      {isVisible && (
        <div id="fourh-pdf-list" className="listOfPdfs">
          {pdfs.length === 0 ? (
            <p className="fourHEmptyMessage">
              No assessment PDFs were found.
            </p>
          ) : (
            <div className="fourHTableWrapper">
              <table className="fourHAdminTable">
                <thead>
                  <tr>
                    <th scope="col">User ID</th>
                    <th scope="col">Test ID</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {pdfs.map((pdf) => {
                    const pdfKey = `${pdf.user_id}-${pdf.test_id}`;
                    const isDeleting =
                      deletingKey === pdfKey;

                    return (
                      <tr key={pdfKey}>
                        <td data-label="User ID">
                          {pdf.user_id}
                        </td>

                        <td data-label="Test ID">
                          {pdf.test_id}
                        </td>

                        <td data-label="Actions">
                          <button
                            type="button"
                            className="deletePdfBtn"
                            onClick={() =>
                              deletePdf(
                                pdf.user_id,
                                pdf.test_id
                              )
                            }
                            disabled={isDeleting}
                          >
                            {isDeleting
                              ? "Deleting..."
                              : "Delete PDF"}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </section>
  );
}